// 1.导入vuex
import {createStore} from "vuex";



//2.创建store对象
const store = createStore({
    state(){
        return{
            // 验证码标识
            yzmflag:true,
            mbvalue:""
        }
    }
})
//3.导出
export default store;